export default {
  GerarBoletoCartao: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "gerar-boleto-cartao"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/GerarBoletoCartao.js
// module id = sEhu
// module chunks = 16